/* Minimal promise concurrency gate.
   window.AsyncLimiter.createLimiter(maxConcurrent) returns run(task) that waits for a free slot. */
(() => {
  if (window.AsyncLimiter) return;

  const createLimiter = (maxConcurrent) => {
    let active = 0;
    const waiting = [];

    const release = () => {
      active -= 1;
      waiting.shift()?.();
    };

    const acquire = () => new Promise((resolve) => {
      const start = () => {
        active += 1;
        resolve();
      };
      if (active < maxConcurrent) {
        start();
      } else {
        waiting.push(start);
      }
    });

    return async (task) => {
      await acquire();
      try {
        return await task();
      } finally {
        release();
      }
    };
  };

  window.AsyncLimiter = Object.freeze({ createLimiter });
})();
